import { render, staticRenderFns } from "./GaugeChartCallsReport.vue?vue&type=template&id=6b591559&scoped=true"
import script from "./GaugeChartCallsReport.vue?vue&type=script&lang=js"
export * from "./GaugeChartCallsReport.vue?vue&type=script&lang=js"
import style0 from "./GaugeChartCallsReport.vue?vue&type=style&index=0&id=6b591559&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b591559",
  null
  
)

export default component.exports